/**
 * Execution Monitor
 * Logs timestamps of key lifecycle events to debug script loading order.
 */
(function() {
  window.executionLog = [];
  
  function log(event) {
    const time = performance.now().toFixed(2);
    const entry = `[ExecutionMonitor] ${time}ms - ${event}`;
    window.executionLog.push(entry);
    console.debug(entry);
  }

  log('Execution Monitor Initialized');

  document.addEventListener('DOMContentLoaded', () => {
    log('DOMContentLoaded');
  });

  window.addEventListener('load', () => {
    log('Window Load');
  });

  // Expose a helper to let other scripts log their readiness
  window.logScriptExecution = function(scriptName) {
    log(`Script Executed: ${scriptName}`);
  };

  // CLS Monitoring
  try {
    let clsValue = 0;
    const observer = new PerformanceObserver((entryList) => {
      for (const entry of entryList.getEntries()) {
        if (!entry.hadRecentInput) {
          clsValue += entry.value;
          console.debug(`[CLS] Shift detected: ${entry.value.toFixed(4)}. Total CLS: ${clsValue.toFixed(4)}`, entry.sources);
        }
      }
    });

    observer.observe({type: 'layout-shift', buffered: true});
    window.getCLS = () => clsValue;
  } catch (e) {
    console.warn('[ExecutionMonitor] CLS monitoring not supported.');
  }
})();
